import React from "react";
import type { IMemberDetail } from "service/interface/member";

interface Props {
  data: IMemberDetail;
  setData: React.Dispatch<React.SetStateAction<IMemberDetail>>;
}

export function MemoTable({ data, setData }: Props) {
  const handleMemoInput = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setData((prev) => ({
      ...prev,
      memo: e.target.value,
    }));
  };

  return (
    <div>
      <div className="mb-[24px] flex items-center justify-between">
        <p className="m-0 text-[24px] font-semibold leading-[30px] text-black">
          메모
        </p>
      </div>
      <textarea
        value={data.memo}
        onChange={handleMemoInput}
        className="m-0 h-[201px] w-full resize-none rounded-[8px] border-[1px] border-[#dadada] bg-[#fafafa] px-[16px] py-[24px] text-M3 text-gray-5 outline-none focus:border-gray-5 focus:ring-0"
      />
    </div>
  );
}
